export default "__VITE_ASSET__DGOhLDyz__"